<script>
  import resources from './resources'

  export default {
    name: 'professional-schedulings-index',
    mixins: [resources],
    data () {
      return {
        date: new Date(),
        config: {
          locale: 'pt-br',
          format: 'DD/MM/YYYY',
          useCurrent: false,
          widgetPositioning: {
            horizontal: 'left',
            vertical: 'bottom'
          }
        },
        showMenu: false
      }
    }
}
</script>

<template lang="pug">
  .col-xs-12.col-sm-9.col-md-10.content-wrapper

    medibook-alert-error(
      :show='showIsReverser',
      @close='(showBeforeDate = false)(showIsReverser = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Horário(s) foram revertido(s) com sucesso.')

    medibook-alert-error(
      :show='showIsRollback',
      @close='(showBeforeDate = false)(showIsRollback = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Horário(s) retornarm a sua sistação de origem com sucesso.')


    medibook-alert-error(
      :show='showIsPresent',
      @close='(showBeforeDate = false)(showIsPresent = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Horário(s) confirmado(s) como presente(s) com sucesso.')

    medibook-alert-error(
      :show='showIsAttendance',
      @close='(showBeforeDate = false)(showIsAttendance = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Horário(s) confirmado(s) como em atendimento(s) com sucesso.')

    medibook-alert-error(
      :show='showIsCanceled',
      @close='(showBeforeDate = false)(showIsCanceled = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Horário(s) confirmado(s) como cancelado(s) com sucesso.')

    medibook-alert-error(
      :show='showIsAbsent',
      @close='(showBeforeDate = false)(showIsAbsent = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Horário(s) confirmado(s) como ausente(s) com sucesso.')

    medibook-alert-error(
      :show='showIsScheduled',
      @close='(showBeforeDate = false)(showIsScheduled = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Horário(s) confirmado(s) como agendado(s) com sucesso.')

    medibook-alert-error(
      :show='showIsTransferred',
      @close='(showBeforeDate = false) (showIsTransferred = false)',
      title='Atenção',
      type='sa-success',
      buttonAction="Fechar",
      message='Transferência efetuada com sucesso.')

    medibook-alert-error(
        :show='showIsDelayed',
        @close='(showBeforeDate = false) (showIsDelayed = false)',
        title='Atenção',
        type='sa-success',
        buttonAction="Fechar",
        message='Horário(s) confirmado(s) como atrasado com sucesso.')

    medibook-alert-error(
        :show='showIsAttended',
        @close='(showBeforeDate = false) (showIsAttended = false)',
        title='Atenção',
        type='sa-success',
        buttonAction="Fechar",
        message='Horário(s) confirmado(s) como atendido com sucesso.')

    medibook-alert-error(
      :show='showBeforeDate',
      @close='showBeforeDate = false',
      title='Atenção',
      type='sa-warning',
      buttonAction="Fechar",
      message='Atenção a data final deve ser maior que a data inicial.')

    modal(
      :visible="showModalPresent",
      name="schedule_present",
      height="auto",
      @close="hideShowModalPresent"
    )
      present(v-if="showModalPresent", :schedules="schedulesSelected", @close="onClosePresent")


    modal(
      :visible="showModalInAttendance",
      name="schedule_from_delayed",
      height="auto",
      @close="hideShowModalInAttendance"
    )
      in-attendance(v-if="showModalInAttendance", :schedules="schedulesSelected", @close="onCloseInAttendance")


    modal(
      :visible="showModalFromDelayedRollback",
      name="schedule_from_delayed",
      height="auto",
      @close="hideShowModalFromDelayedRollback"
    )
      rollback-from-delayed(v-if="showModalFromDelayedRollback", :schedules="schedulesSelected", @close="onCloseFromFromDelayedRollback")


    modal(
      :visible="showModalDelayed",
      name="schedule_delayed",
      height="auto",
      @close="hideShowModalDelayed"
    )
      delayed(v-if="showModalDelayed", :schedules="schedulesSelected", @close="onCloseDelayed")

    modal(
      :visible="showModalRollback",
      name="schedule_rollback",
      height="auto",
      @close="hideShowModalRollback"
    )
      rollback(v-if="showModalRollback", :schedules="schedulesSelected", @close="onCloseRollback")

    modal(
      :visible="showModalCancel",
      name="schedule_canceled",
      height="auto",
      @close="hideShowModalCancel"
    )
      cancel(v-if="showModalCancel", :schedules="schedulesSelected", @close="onCloseCancel")

    modal(
      :visible="showModalConfirmed",
      name="schedule_confirmed",
      height="auto",
      @close="hideshowModalConfirmed"
    )
      confirmed(v-if="showModalConfirmed", :schedules="schedulesSelected", @close="onCloseConfirmed")

    modal(
      :visible="showModalReverser",
      :name="'schedule_reverser' + currentSchedule.id",
      height="auto",
      @close="hideShowModalReverser"
    )
      reverser(v-if="showModalReverser", :schedule="currentSchedule", @close="onCloseReverser")

    modal(
      :visible="showModalTransfer",
      :name="'schedule_transfer' + currentSchedule.id",
      height="auto",
      @close="hideShowModalTransfer"
    )
      transfer(v-if="showModalTransfer", :schedule="currentSchedule", @close="onCloseTransfer")

    modal(
      :visible="showModalAbsent",
      :name="'schedule_transfer' + currentSchedule.id",
      height="auto",
      @close="hideShowModalAbsent"
    )
      absent(v-if="showModalAbsent", :schedules="schedulesSelected", @close="onCloseAbsent")


    .inner-title.two-lines
      h2
        span.first-line
          span.icon 
          |  Minha Agenda
        span.hifen  —
        span.second-line Lista de Agendamentos

    .col-xs-12.content
      .container-fluid
        .row
          .col-xs-12.col-md-8
            v-input(:status="$v.search.agenda_id.$error ? 'error' : null")
              f-select-professional-agenda(label="Agenda Médica",
                name="agenda_id",
                :get-all="true",
                v-model="search.agenda_id")

          .col-xs-12.col-md-4(style='margin-bottom:15px;')
              f-select(label="Situação",
                name="status",
                :options="optionsStatus",
                v-model="search.status")
        .row
          .col-xs-12.col-sm-2.margin-bottom
              v-input(:status="$v.search.date_start.$error ? 'error' : null")
                label Data inicial
                v-datepicker(
                  v-model="search.date_start",
                  name="date_start",
                  :config='config')

          .col-xs-12.col-sm-2.margin-bottom
              v-input(:status="$v.search.date_end.$error ? 'error' : null")
                label.label-floating.margin-bottom-10.label-floating Data final
                v-datepicker(
                  v-model="search.date_end",
                  name="date_end",
                  :config='config')

          .col-xs-12.col-sm-2.margin-bottom
            button.btn.save-filled(@click.prevent="doLoadAll(true)", style='margin-top: 20px')
              span.icon 
              | Localizar

        .row(v-if="loading")
          spinner-professional(:show="true")
        .row(v-if="!loading")
          section.gadget-agenda-estatisticas.white-bg.wrapper.full-width.gadget(v-if=" schedules.length <= 0")
            .actions
            div.text-center
              h2.center
                br
                |Nenhum resultado localizado


          .panel.panel-default(style="margin-top: 0px;", v-if=" schedules.length > 0")
            .panel-body
                table.table.table-striped
                  thead.white-bg
                    tr
                      th.col-md-1
                        input.check(type='checkbox', @change="selectAll" v-model="all")
                        |&nbsp; Data
                      th.col-md-1 Hora
                      th.col-md-4 Profissional
                      th.col-md-3 Paciente
                      th.col-md-2 Situação
                      th.col-md-2.text-center Ações
                  tbody
                    tr(v-for="schedule in schedules", style="padding: 0px 0px;")
                      td.check(style="padding: 5px;")
                        input.check(v-if="schedule.status !== 'canceled'", type='checkbox', v-model="schedule._selected")
                        small.grey
                        | &nbsp; {{ schedule.date }}
                      td
                        small.grey
                        | {{ schedule.time }}
                      td
                        small.grey
                        | {{ schedule.agenda.professional.name }}
                      td
                        small.grey
                        | {{ schedule.patient.name }}
                      td
                        .input-group
                          select.form-control(name='schedule.id', key="schedule.id", @change='onSelectedRunAction(schedule.status, schedule)', v-model='schedule.status')
                            option(v-for='(item, index) in optionLoadActions', :value='item.value') {{item.text}}
                          span.input-group-addon.blue-addon
                            span.icon 

                      td.text-center.scheduling
                        //- span.icon.revert(v-if="schedule.status === 'attended'", @click="doRollback(schedule, false)",   v-tooltip="'Confirmar Atendimento'")
                          i.fa.fa-refresh.icon
                        //- span.icon.revert(v-if="schedule.status === 'scheduled'", @click="doConfirmed(schedule, false)") 
                        //- span.icon.exclusion(v-if="schedule.status !== 'canceled'", @click="doCancel(schedule, false)") 
                        span.icon.revert.mb-cursor-point(v-if="schedule.transfer_id && schedule.status !== 'attended'", @click="doReverser(schedule)",  v-tooltip="'Reveter Transferência'") 

                        span.icon.transfer.mb-cursor-point(v-if="schedule.status === 'scheduled'", @click="doTransfer(schedule)", v-tooltip="'Transferir Paciente'") 


        .row
          .col-xs-12.col-sm-4
            f-select-status.select-custom(label="Aplicar situação para diversos pacientes",
              name="status",
              v-if="hasSelected",
              :options="optionActions",
              menu-direction="top",
              @selected="onSelectedAction")
        .row(style="margin-bottom: 30px;")
          .pagination
            pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/professional/schedulings/index/index.vue